<template>
  <div>
    <el-card>
      <div style="display: flex">
        <div style="width: 50%">
          <el-form>
            <el-row>
              <el-col :md="24">
                <el-form-item :rules="{ required: true }" label="备注：" label-width="80px">
                  <el-input v-model="prop.remark" :disabled="true" type="textarea"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <el-form :disabled="true" label="right" label-width="100px">
            <el-row>
              <el-form-item label="制作人：" size="small">
                <el-input :value="prop.stff_name" show-word-limit> </el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="岗位：" size="small">
                <el-input :value="prop.user_jobs" show-word-limit> </el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="难度系数：" size="small">
                <el-input :value="prop.price" disabled show-word-limit> </el-input>
              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  props: ['prop'],
  mounted() {
    console.error(this.prop);
  }
};
</script>

<style lang="scss" scoped></style>
